<div class="drawer drawer-end">

    <input id="schedule_drawer" type="checkbox" class="drawer-toggle" [checked]="isDrawerOpen()" />

    <div class="drawer-side z-50">
        @if (drawerType() && drawerType() == 'view') {
            <div (click)="close()" class="drawer-overlay"></div>
        }@else {
            <div class="drawer-overlay"></div>
        }
        <div class="menu w-[27rem] bg-white text-base-content min-h-full p-4">

            <div class="flex justify-between items-center">
                <span></span>
                <!-- <h2 class="font-semibold uppercase text-blue-600">Lecture</h2> -->
                <div class="flex items-center gap-2">
                    @if (drawerType() && drawerType() == 'view') {
                    <button class="btn btn-sm btn-circle" (click)="edit()"><i class="ri-pencil-line"></i></button>
                    <button class="btn btn-sm btn-circle" (click)="delete()"><i class="ri-delete-bin-line"></i></button>
                    }
                    <button class="btn btn-sm btn-circle" (click)="close()"><i class="ri-close-line"></i></button>
                </div>
            </div>
            <hr class="my-3">

            @if (drawerType() && drawerType() == 'view') {
            <app-schedule-view></app-schedule-view>
            }@else if (drawerType() && drawerType() == 'form') {
            <app-schedule-form></app-schedule-form>
            }



        </div>
    </div>
</div>